import { jsx as _jsx } from "react/jsx-runtime";
import {} from 'react';
import { cva } from 'class-variance-authority';
import { cn } from '../lib/utils.js';
/** Display label per reward type — reuse for a tooltip when the pill itself truncates. */
export const REWARD_LABELS = {
    freebet: 'Bonus Bet',
    profitboost: 'Profit Boost',
    parlay: 'Parlay Escalator',
};
const rewardVariants = cva('inline-flex items-center whitespace-nowrap rounded-[6px] px-2.5 py-1 font-ui text-xs font-semibold leading-[1.3]', {
    variants: {
        type: {
            freebet: 'bg-reward-freebet-bg text-reward-freebet-text',
            profitboost: 'bg-reward-profitboost-bg text-reward-profitboost-text',
            parlay: 'bg-reward-parlay-bg text-reward-parlay-text',
        },
    },
    defaultVariants: { type: 'freebet' },
});
export function RewardPill({ type = 'freebet', label, className, ...rest }) {
    return (_jsx("span", { "data-type": type, className: cn(rewardVariants({ type }), className), ...rest, children: label ?? REWARD_LABELS[type] ?? type }));
}
//# sourceMappingURL=reward-pill.js.map